import React from "react";
import { motion } from "framer-motion";
import { AppleLogo, GooglePlayLogo } from "./StoreIcons";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-24 md:py-36 bg-transparent overflow-hidden"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-[#3056F5] font-bold tracking-[0.35em] text-xs mb-6"
        >
          QONTRI.IN
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display uppercase text-[#0F2C5A] leading-[0.95] text-[clamp(2.4rem,7vw,6rem)]"
        >
          Split smart.
          <br />
          <span className="text-[#3056F5]">Settle simple.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="mt-8 text-base md:text-lg text-[#14254B]/80 max-w-xl mx-auto"
        >
          Be the friend who never owes anyone anything. Download Qontri and end
          the awkward "who paid for the cab?" forever.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="mt-10 flex flex-col sm:flex-row gap-4 items-center justify-center"
        >
          <a
            href="#"
            data-testid="final-cta-appstore"
            className="inline-flex items-center gap-3 bg-[#0F2C5A] hover:bg-[#14254B] text-white pl-5 pr-7 py-3.5 rounded-2xl transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-[#0F2C5A]/30"
          >
            <AppleLogo className="w-7 h-7" />
            <span className="text-left leading-none">
              <span className="block text-[10px] tracking-widest opacity-70">
                DOWNLOAD ON THE
              </span>
              <span className="block font-display text-xl tracking-tight">
                App Store
              </span>
            </span>
          </a>
          <a
            href="#"
            data-testid="final-cta-googleplay"
            className="inline-flex items-center gap-3 bg-[#3056F5] hover:bg-[#2546D4] text-white pl-5 pr-7 py-3.5 rounded-2xl transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-[#3056F5]/40"
          >
            <GooglePlayLogo className="w-6 h-6" />
            <span className="text-left leading-none">
              <span className="block text-[10px] tracking-widest opacity-80">
                GET IT ON
              </span>
              <span className="block font-display text-xl tracking-tight">
                Google Play
              </span>
            </span>
          </a>
        </motion.div>
      </div>
    </section>
  );
}
